import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import ServiceCollectionService from '../../../../../fulfillment-planner/rate-and-create-label/service-collection-service';
import ServiceDetailsWrapper from '../../service-details/service-details-wrapper';
import { Delivery, Pickup } from '../../service-details-fields';

import serviceDetailsFieldStyle from '../../service-details-fields/service-details.module.less';
import textStyle from 'ui-components/components/text/text.module.less';

const ServiceDetails = ({
  fulfillmentPlanId,
  estimatedPickup,
  estimatedDelivery,
  shouldShowRateShopperSelectedService = false,
  isPickupServiceSelected = false,
}) => {
  return (
    <ServiceDetailsWrapper>
      {shouldShowRateShopperSelectedService && (
        <ServiceCollectionService
          className={classnames(serviceDetailsFieldStyle['service-details-field'], textStyle.label)}
          dataClassName={classnames(serviceDetailsFieldStyle['service-details-field'], textStyle.caption)}
          fulfillmentPlanId={fulfillmentPlanId}
        />
      )}
      {isPickupServiceSelected && <Pickup pickupDateTime={estimatedPickup} />}
      <Delivery deliveryDateTime={estimatedDelivery} label={<FormattedMessage {...messages.arrivalLabel} />} />
    </ServiceDetailsWrapper>
  );
};

export default ServiceDetails;

ServiceDetails.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  estimatedPickup: PropTypes.string,
  estimatedDelivery: PropTypes.string,
  shouldShowRateShopperSelectedService: PropTypes.bool,
  isPickupServiceSelected: PropTypes.bool,
};
